import { type FC } from 'react';
import { BaseEdge, getBezierPath, type EdgeProps } from 'reactflow';
import type { LinkData } from '@/types/link.types';

const COMPLEMENTARITY_COLOR = '#3B82F6';

export const ComplementarityEdge: FC<EdgeProps<LinkData>> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  style,
}) => {
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  return (
    <BaseEdge
      id={id}
      path={edgePath}
      markerEnd={markerEnd}
      style={{
        stroke: COMPLEMENTARITY_COLOR,
        strokeWidth: 2,
        strokeDasharray: '12 6',
        ...style,
      }}
    />
  );
};

export default ComplementarityEdge;
